module.exports = __webpack_public_path__ + "monitor.b45ed8428d57fe04e6cb";


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/assets/img/admin/monitor.jpg
// module id = ../../../../../src/assets/img/admin/monitor.jpg
// module chunks = main